var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.082 15.9753L14.9914 12.844C14.9037 12.7877 14.8043 12.7524 14.7007 12.7409L12.5539 12.4503C12.3937 12.4273 12.2304 12.4581 12.0896 12.5378C11.9488 12.6175 11.8384 12.7417 11.7757 12.8909L10.4914 15.769C10.431 15.9029 10.4112 16.0516 10.4346 16.1966C10.4579 16.3416 10.5233 16.4765 10.6226 16.5847L12.3851 18.4878C12.4648 18.5754 12.5232 18.6801 12.5557 18.794C12.5882 18.9078 12.594 19.0276 12.5726 19.144L12.207 21.0003",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09281 5.2124L5.24906 7.1999C5.17557 7.37635 5.17222 7.57419 5.23969 7.75303L6.31781 10.6218C6.35995 10.7413 6.43207 10.8481 6.52728 10.9318C6.62248 11.0155 6.73758 11.0734 6.86156 11.0999L8.86781 11.5312C8.97917 11.5537 9.08374 11.6018 9.17324 11.6718C9.26275 11.7418 9.33471 11.8316 9.38344 11.9343L9.73969 12.6749C9.80299 12.8001 9.89935 12.9056 10.0183 12.98C10.1373 13.0544 10.2744 13.0948 10.4147 13.0968H11.6803",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2973 3.29053L15.1691 4.86553C15.2496 5.0136 15.2786 5.18425 15.2514 5.35058C15.2243 5.51692 15.1426 5.6695 15.0191 5.78428L12.4973 8.0624C12.455 8.10271 12.4078 8.13738 12.3566 8.16553L11.2035 8.80303C11.0936 8.86135 10.9717 8.89344 10.8473 8.89678H8.84102C8.69322 8.89753 8.54886 8.94139 8.42562 9.02299C8.30239 9.10459 8.20565 9.22038 8.14727 9.35615L7.36914 11.203",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.7d331eebb6337fef4d9e18f2ffd006ef.svg";
export { ForwardRef as ReactComponent };